import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment-timezone';
import { StartEndTime } from '@app/shared/components/start-end-time/start-end-time.component';
import { ThermalComfortSchedule } from '@app/graphql-typings/graphql';

export class AddEditUtility {

  static ngbTimeToString(time: NgbTimeStruct): string | null {
    return time == null ? null : ('00' + time.hour).slice(-2) + ':' + ('00' + time.minute).slice(-2);
  }

  static isValidHour(hour: string): boolean {
    return !isNaN(parseInt(hour, 10));
  }

  static ensureValidTime(time: string): string {
    let validTime = time;
    if (!AddEditUtility.isValidHour(time.split(':')[0]) || !AddEditUtility.isValidHour(time.split(':')[1])) {
      validTime = '00:00';
    }
    return validTime;
  }

  static stringToNgbTime(time: string): NgbTimeStruct {
    const validTime = AddEditUtility.ensureValidTime(time);
    return <NgbTimeStruct>{
      hour: +validTime.split(':')[0],
      minute: +validTime.split(':')[1],
      second: 0
    };
  }

  static dateToString(date: Date): string {
    return moment(date).format('YYYY-MM-DDTHH:mm:ss');
  }

  // convert backend thermalcomfort schedule to be input of StartEndTimeComponent
  static fromThermalcomfortScheduleToStartEndTime({day_start, day_end, exclude_weekends}: ThermalComfortSchedule): StartEndTime {
    return {
      startTime: AddEditUtility.stringToNgbTime(day_start),
      endTime: AddEditUtility.stringToNgbTime(day_end),
      excludeWeekends: exclude_weekends
    };
  }

  // convert value of StartEndTimeComponent to be backend thermalcomfort schedule
  static fromStartEndTimeToThermalcomfortSchedule({ startTime, endTime, excludeWeekends }: StartEndTime): ThermalComfortSchedule {
    return {
      day_start: AddEditUtility.ngbTimeToString(startTime),
      day_end: AddEditUtility.ngbTimeToString(endTime),
      exclude_weekends: excludeWeekends
    };
  }

}
